import { reRoomyPrivacyExtended } from './apps/re-roomy/reRoomyExtended';
import { iMealPrivacyExtended } from './apps/i-meal/iMealExtended';
import { tcgScannerPrivacyExtended } from './apps/tcg-scanner/tcgScannerExtended';

/** Full privacy page content per app slug. Missing slug → /{slug}/privacy-policy shows 404. */
export function getPrivacyPageContent(appSlug) {
  if (appSlug === 're-roomy') {
    return reRoomyPrivacyExtended;
  }
  if (appSlug === 'i-meal') {
    return iMealPrivacyExtended;
  }
  if (appSlug === 'tcg-scanner') {
    return tcgScannerPrivacyExtended;
  }
  return null;
}
